import client from './client';

export const fetchExam = async (examId) => {
  const res = await client.get(`/api/exam/${examId}`);
  return res.data;
};

export const checkDuplicate = async (examId, studentName) => {
  const res = await client.get(`/api/check-duplicate/${examId}/${studentName}`);
  return res.data;
};

export const createExam = async (examData) => {
  const res = await client.post('/api/exam', examData);
  return res.data;
};

export const fetchExams = async () => {
  const res = await client.get('/api/exams');
  return res.data;
};
